// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__3YGJN","mobile":"Footer_mobile__1Gcp_","centered":"Footer_centered__mI1jS","logo":"Footer_logo__1kKTy","desktop":"Footer_desktop__1O-h0"};